
import { Component, Prop, Vue } from 'vue-property-decorator';
import TextQuestion from '@/components/TextQuestion.vue';
import NumberQuestion from '@/components/NumberQuestion.vue';
import SubQuestion from '@/components/SubQuestion.vue';
import DateQuestion from '@/components/DateQuestion.vue';
import RadioQuestion from '@/components/RadioQuestion.vue';
import EntityQuestion from '@/components/EntityQuestion.vue';
import DatePickerQuestion from '@/components/DatePickerQuestion.vue';
import store from '@/store';
import Response from '@/lib/Response';
import VisualChoiceQuestion from '@/components/VisualChoiceQuestion.vue';
import CustomRoomsValueQuestion from '@/components/CustomRoomsValueQuestion.vue';
import CustomValuableThingsQuestion from '@/components/CustomValuableThingsQuestion.vue';
import CustomFancyThingsQuestion from '@/components/CustomFancyThingsQuestion.vue';
import { Question as QuestionEntity } from '@/lib/Question';
import HiddenQuestion from '@/components/HiddenQuestion.vue';
import TextareaQuestion from './TextareaQuestion.vue';
import SinisterQuestion from './SinisterQuestion.vue';
import SimpleGuaranteeQuestion from './SimpleGuaranteeQuestion.vue';
import ExcelUploadQuestion from './ExcelUploadQuestion.vue';
import GuaranteeFullQuestion from './GuaranteeFullQuestion.vue';
import ImageUploadQuestion from './ImageUploadQuestion.vue';
import FileUpload from './FileUpload.vue';
import VidNumberQuestion from '@/components/VidNumberQuestion';
import { ResponseGroup } from '../lib/ResponseGroup';
import router from '../router';

@Component(
    {
        components: {
            FileUpload,
            ImageUploadQuestion,
            GuaranteeFullQuestion,
            CustomFancyThingsQuestion,
            CustomValuableThingsQuestion,
            CustomRoomsValueQuestion,
            VisualChoiceQuestion,
            TextQuestion,
            NumberQuestion,
            DateQuestion,
            DatePickerQuestion,
            RadioQuestion,
            EntityQuestion,
            SubQuestion,
            HiddenQuestion,
            TextareaQuestion,
            SimpleGuaranteeQuestion,
            SinisterQuestion,
            ExcelUploadQuestion,
            VidNumberQuestion,
        },
    },
)
export default class Question extends Vue {
    @Prop() public question?: QuestionEntity;
    @Prop() public oneone: boolean;
    public currentQuestion = this.$store.state.currentBranch.currentQuestion;
    public nextDisabled = true;

    public enter(e) {
        if (e.key === "Enter") {
            if (!this.nextDisabled) {
                if (this.$store.state.currentBranch.validQuestions.length < this.$store.state.currentBranch.questions.length) {
                    this.next();
                } else {
                    this.nextStep();
                }
            }
        }

    }

    public next() {
        // console.log('-----------------')
        // console.log('valid : '+this.$store.state.currentBranch.validQuestions.length)
        // console.log('all : '+this.$store.state.currentBranch.questions.length)
        this.$store.state.currentBranch.next();
        this.currentQuestion = this.$store.state.currentBranch.currentQuestion;
        this.disable();
        if (this.$store.state.currentBranch.validQuestions.length === this.$store.state.currentBranch.questions.length && this.$store.state.currentBranch.activateComparison) {
            this.nextStep()
        }
        // console.log('-----------------')
        // console.log('valid : '+this.$store.state.currentBranch.validQuestions.length)
        // console.log('all : '+this.$store.state.currentBranch.questions.length)
        // this.scrollToLastQuestion();
    }
    public disable() {
        this.question.stepValidation();
        this.nextDisabled = (this.question.required && this.question.currentResponseIsEmpty()) || !this.question.good;
    }

    public scrollToLastQuestion() {
        const length = this.$store.state.currentBranch.validQuestions.length;
        if (length === 0) {
            return;
        }
        const lastQuestion = this.$store.state.currentBranch.validQuestions[length - 1];
        const refs = this.$parent.$refs['question-' + lastQuestion.id];
        const elm = refs[0].$el;
        elm.parentElement.scroll(0, elm.offsetTop - elm.offsetHeight);
    }
    public nextStep() {

        this.$store.state.currentStep.validate();
        // console.log(this.$store.state.currentStep)
        // return
        if (!this.$store.state.currentStep.isValid) {
            return
        }else{
            
        }
        // if (this.getLastStepButtonText() === 'Comparer') {
        //     this.nextStep()
        // }
        // @ts-ignore
        window.gtag_report_conversion();
        if (this.$store.state.currentBranch.activateComparison) {
            // console.log('compare')
            // @ts-ignore
            window.fbq('track', 'Lead');
            if (this.$router.currentRoute.name !== 'comparisonResult' || this.$router.currentRoute.params.responseGroupId !== this.$store.state.currentResponseGroup.id) {
                // @ts-ignore
                router.push({ name: 'comparisonResult', params: { responseGroupId: this.$store.state.currentResponseGroup.id } });
            }
        } else {
            console.log('requestCOtation')
            // @ts-ignore
            window.fbq('track', 'Lead');
            // @ts-ignore
            // console.log(window.fbq);
            this.$store.state.currentResponseGroup.requestQuotation();
        }
    }
    public getLastStepButtonText() {
        const responseGroup = this.$store.state.currentResponseGroup as ResponseGroup;
        if (!responseGroup.branch.activateComparison) {
            return 'Demander une quotation';
        }
        if (responseGroup.contractGroup) {
            return 'Enregistrer';
        }
        return 'Comparer';
    }
    public created() {
        // console.log(this.question);
        // if (!this.question.currentResponse) {
        this.question!.currentResponse = this.getResponseOrCreate();
        this.question!.updateDefaultValue();
        // }
        // console.log(this.question.label + ' => "' + this.question.currentResponse.value + '"');
        // if (!this.question.currentResponse.value) {
        // }
    }

    public getResponseOrCreate(): Response {
        let response = store.getters.getResponse(this.question!);
        if (!response) {
            response = new Response(this.question!, store.state.currentResponseGroup);
            response.additionalIndex = this.question!.section.additionalIndex;
            store.commit('addResponse', response);
        } else {
        }
        return response as Response;
    }

    public mounted() {
        // console.log(this.question)
        // console.log(this.$router.currentRoute.name)
        this.question!.changedEvent.emit('');
        window.M.updateTextFields();
        this.$store.state.currentBranch.questions.forEach((question: any) => question.changedEvent.on(() => this.disable()));
        this.disable();
        // if(this.question.id === 194){
        //     console.log(this.question);
        // }
        window.document.addEventListener('keypress', this.enter);
        if (this.question.responseType.template === "hidden") {
            this.next();
        }
    }

    public destroyed() {
        window.document.removeEventListener('keypress', this.enter);
    }

}
